module.exports = path => /^\/contact\/?$/i.test(path) ? 'Contact' : /^\/styles(?:\/[^/]*_[^/]*(?:\/[^/]*_[^/]*)?)?\/?$/i.test(path) ? 'Catalog' : null;
